import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LINKEDCALENDAR_ENTRY_TYPE } from './constants';

/**
 * Returns whether provided calendar entry is for linked calendar
 * @param calendarEntry, the calendar entry
 * @returns true if calendar entry is for linked calendar
 */
export function isLinkedCalendar(calendarEntry: CalendarEntry): boolean {
    return isFeatureEnabled('cal-linkedCalendarEntry')
        ? calendarEntry.__type == LINKEDCALENDAR_ENTRY_TYPE
        : calendarEntry.hasOwnProperty('OwnerEmailAddress');
}
